import React from "react";
import { Gpt } from "../base/Gpt";
import { MISSION_CONFIG } from "./missionConfig";

export default function MissionGpt(props) {
  return (
    <Gpt
      {...props}
      workshopConfig={MISSION_CONFIG.gpt}
      storageKey={MISSION_CONFIG.storageKeys.gptMessages}
    />
  );
}
